import { useQuery } from "react-query";
import { insightsMetaQuery } from "src/pages/ad-studio/insights/performance/insights-meta-query";
import type { InsightsMetaResult } from "src/pages/ad-studio/insights/performance/types";
import { toResponseFailure } from "src/pages/ad-studio/insights/performance/utils/cube-api";
import { toMetaResult } from "src/pages/ad-studio/insights/performance/utils/meta";

export function useInsightsMeta(): InsightsMetaResult {
  const { data, error } = useQuery({
    ...insightsMetaQuery,
    select: toMetaResult,
  });
  if (error instanceof Error) {
    return { status: "failed", failure: toResponseFailure(error) };
  }
  return data ?? { status: "loading" };
}
